import { styled } from "sharedUI/styles";
import { Badge } from "../../../../ui/views/badge/badge";

export const IconBadge = styled(Badge)`
    top: 38px;
    left: 50px;
    right: unset;
    bottom: unset;
    font-size: 10px;
    height: 16px;
    border: 1px solid ${p => p.theme.fgColorAccent};
    padding: 0 6px;
`;
